import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

export const authGuard: CanActivateFn = () => {
  const msalService = inject(MsalService);
  const router = inject(Router);

  const account = msalService.instance.getActiveAccount() ?? msalService.instance.getAllAccounts()[0] ?? null;
  if (account) {
    if (!msalService.instance.getActiveAccount()) {
      msalService.instance.setActiveAccount(account);
    }
    return true;
  }

  return router.parseUrl('/login');
};
